// Company Landing ********************************************************************************
// pathname: /v1/company/onboarding
// ************************************************************************************************
import {
  useSwrApi,
} from 'src/hooks/useSwrApi';
import { useExtendedRouter } from '@hooks/next-routing-wrappers';


/**
 * @description SWR: fetch company data.
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 * @param shouldFetch - { boolean } - if we should fetch the data. Default true.
 */
export const useSwrCompanyOnboarding = (locale = 'ro', shouldFetch = true) => {
  // Router
  const { router } = useExtendedRouter();

  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'CompanyRead'>>({
    url: '/v1/company/onboarding',
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 1000 * 60, // 1 minute
      // redirect to login page if we get a 401
      onError: (newError) => {
        if (newError?.errors[0].code === 401) {
          void router.push('/login');
        }
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
